import { formatDateTimeWithOptionsBs, formatDateWithOptionsBs } from "@/lib/format";

export function formatDate(iso: string): string {
  return formatDateWithOptionsBs(iso, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}

export function formatDateTime(iso: string): string {
  return formatDateTimeWithOptionsBs(iso, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Sarajevo",
  });
}
